import { postWithOutAuth } from '@services/http.service';
import { LOGOUT } from '@services/url.service';

export const logout = () => postWithOutAuth(LOGOUT());
